$(document).ready(function () {
    
    let zigmentSubmissionId = crypto.randomUUID();

    function getUTMParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        
        const utmData = {
            utm_source: urlParams.get('utm_source') || '',
            utm_medium: urlParams.get('utm_medium') || '',
            utm_campaign: urlParams.get('utm_campaign') || '',
            utm_adgroup: urlParams.get('utm_adgroup') || '',
            utm_adset: urlParams.get('utm_adset') || '',
            utm_term: urlParams.get('utm_term') || '',
            utm_ad: urlParams.get('utm_ad') || '',
            utm_city: urlParams.get('utm_city') || '',
            utm_destination: urlParams.get('utm_destination') || '',

            utm_content: urlParams.get('utm_content') || '',
            gclid: urlParams.get('gclid') || '',
            fbclid: urlParams.get('fbclid') || '', 
        };

        return utmData;
    }

    const occasionData = [
        "Bridal",
        "Engagement",
        "Anniversary",
        "Gifting",
        "Festive",
        "Everyday Wear",
        "Just Exploring"
    ];

    if ($('.occasionList').length) {
        let $occasionDropdown = $('.occasionList');
        $occasionDropdown.find('option:not(:first)').remove();
        $.each(occasionData, function (index, occasion) {
            $occasionDropdown.append(
                `<option value="${occasion}">${occasion}</option>`
            );
        });
    }

    const budgetRangeData = [
        "Under ₹25,000",
        "₹25,000 – ₹50,000",
        "₹50,000 – ₹1,00,000",
        "₹1,00,000 – ₹2,50,000",
        "Above ₹2,50,000"
    ];

    if ($('.budgetRangeList').length) {
        let $budgetRangeDropdown = $('.budgetRangeList');
        $budgetRangeDropdown.find('option:not(:first)').remove();
        $.each(budgetRangeData, function (index, budgetRange) {
            $budgetRangeDropdown.append(
                `<option value="${budgetRange}">${budgetRange}</option>`
            );
        });
    }

    const citiesData = {
        bangalore: ["Bangalore"],
        hyderabad: ["Hyderabad"],
        new_delhi: ["New Delhi"],
        delhi: ["Delhi"],
        noida: ["Noida"],
        faridabad: ["Faridabad"],
        gurugram: ["Gurugram"],
        pune: ["Pune"],
        lucknow: ["Lucknow"],
        vizag: ["Vizag"],
        dehradun: ["Dehradun"],
        chennai: ["Chennai"],
    };

    if ($('.allCitiesList').length) {

        let $cityDropdown = $('.allCitiesList');
        $cityDropdown.find('option:not(:first)').remove();
        $.each(citiesData, function (key, cities) {
            $.each(cities, function (index, city) {
                $cityDropdown.append(
                    `<option data-handle="${key}" value="${city}">${city}</option>`
                );
            });
        });

    }

    if ($('.onlyCitiesList').length) {

        let $cityDropdown = $('.onlyCitiesList');
        $cityDropdown.find('option:not(:first)').remove();
        $.each(citiesData, function (key, cities) {
            $.each(cities, function (index, city) {
                $cityDropdown.append(
                    `<option value="${city}">${city}</option>`
                );
            });
        });

    }

    const storesData = {
        bangalore: [
        "Aukera - Dickenson Road, Bangalore",
        "Aukera - Sarjapur, Bangalore",
        "Aukera - HSR Layout, Bangalore",
        "Aukera - Electronic City, Bangalore",
        "Aukera - Jayanagar, Bangalore",
        "Aukera - Orion Mall, Bangalore",
        "Aukera - Whitefield, Bangalore",
        "Aukera - Vega City Mall, Bangalore",
        "Aukera - Banashankari, Bangalore",
        "Aukera - Marathahalli, Bangalore",
        "Aukera - Forum South, Bangalore",
        "Aukera - Indiranagar, Bangalore",
        ],
        hyderabad: [
        "Aukera - Jubilee Hills, Hyderabad",
        "Aukera - Inorbit Mall, Hyderabad",
        "Aukera - Banjara Hills, Hyderabad",
        "Aukera - Somajiguda, Hyderabad",
        "Aukera - Kondapur, Hyderabad",
        "Aukera - Sarath City Mall, Hyderabad",
        "Aukera - Nexus Mall, Hyderabad"
        ],
        new_delhi: [
        "Aukera - Lajpat Nagar, New Delhi",
        "Aukera - Pacific Mall, Pitampura, New Delhi",
        "Aukera - Ambience Mall, New Delhi",
        ],
        delhi: [
        "Aukera - Dwarka, Delhi",
        "Aukera - Rohini, Delhi",
        ],
        noida: [
        "Aukera - Wave One Mall, Noida",
        "Aukera - Aditya Capital Mall, Noida",
        "Aukera - Gaur City Mall, Greater Noida",
        ],
        faridabad: [
        "Aukera - The Mall of Faridabad, Faridabad",
        ],
        gurugram: [
        "Aukera - Good Earth Sixty9 Mall, Gurugram",
        "Aukera - DLF Summit Plaza, Gurugram",
        ],
        pune: [
        "Aukera - Paud Road, Pune",
        "Aukera - Amanora, Pune",
        ],
        lucknow: [
        "Aukera - Lulu Mall, Lucknow",
        ],
        vizag: [
        "Aukera - Inorbit Mall, Vizag",
        ],
        dehradun: [
        "Aukera - Rajpur Road, Dehradun",
        ],
        chennai: [
        "Aukera - Velachery, Chennai",
        "Aukera - Anna Nagar, Chennai",
        ],
    };

    $('.allCitiesList').on('change', function () {

        const selectedHandle = $(this).find(':selected').data('handle');
        const $storeSelect = $('#preferred_store');

        $storeSelect.html('<option selected disabled value="">Select Store</option>');

        if (storesData[selectedHandle]) {
        $.each(storesData[selectedHandle], function (index, store) {
            $storeSelect.append(
            $('<option>', {
                value: store,
                text: store
            })
            );
        });
        }

    });

    const cityStoresData = {
        bangalore: [
        "Aukera - Dickenson Road, Bangalore",
        "Aukera - Sarjapur, Bangalore",
        "Aukera - HSR Layout, Bangalore",
        "Aukera - Electronic City, Bangalore",
        "Aukera - Jayanagar, Bangalore",
        "Aukera - Orion Mall, Bangalore",
        "Aukera - Whitefield, Bangalore",
        "Aukera - Vega City Mall, Bangalore",
        "Aukera - Banashankari, Bangalore",
        "Aukera - Marathahalli, Bangalore",
        "Aukera - Forum South, Bangalore",
        "Aukera - Indiranagar, Bangalore",
        ],
        hyderabad: [
        "Aukera - Jubilee Hills, Hyderabad",
        "Aukera - Inorbit Mall, Hyderabad",
        "Aukera - Banjara Hills, Hyderabad",
        "Aukera - Somajiguda, Hyderabad",
        "Aukera - Kondapur, Hyderabad",
        "Aukera - Sarath City Mall, Hyderabad",
        "Aukera - Nexus Mall, Hyderabad",
        ],
        delhi_ncr: [
        "Aukera - Lajpat Nagar, New Delhi",
        "Aukera - Dwarka, New Delhi",
        "Aukera - Rohini, Delhi",
        "Aukera - Wave One Mall, Noida",
        "Aukera - Aditya Capital Mall, Noida",
        "Aukera - Gaur City Mall, Greater Noida",
        "Aukera - The Mall of Faridabad, Faridabad",
        "Aukera - Good Earth Sixty9 Mall, Gurugram",
        "Aukera - Pacific Mall, Pitampura, New Delhi",
        "Aukera - Ambience Mall, New Delhi",
        "Aukera - DLF Summit Plaza, Gurugram",
        ],
        noida: [
        "Aukera - Wave One Mall, Noida",
        "Aukera - Aditya Capital Mall, Noida",
        "Aukera - Gaur City Mall, Greater Noida",
        ],
        gurugram: [
        "Aukera - Good Earth Sixty9 Mall, Gurugram",
        "Aukera - DLF Summit Plaza, Gurugram",
        ],
        faridabad: [
        "Aukera - The Mall of Faridabad, Faridabad",
        ],
        dehradun: [
        "Aukera - Rajpur Road, Dehradun",
        ],
        vizag: [
        "Aukera - Inorbit Mall, Vizag",
        ],
        pune: [
        "Aukera - Paud Road, Pune",
        "Aukera - Amanora, Pune",
        ],
        lucknow: [
        "Aukera - Lulu Mall, Lucknow",
        ],
        chennai: [
        "Aukera - Velachery, Chennai",
        "Aukera - Anna Nagar, Chennai",
        ],
    };

    if ($('.staticCityName').length) {
        const cityKey = $('.staticCityName').data('citykey');
        const storesList = cityStoresData[cityKey] || [];
        const $cityWiseStoreList = $('.cityWiseStoreList');
        $cityWiseStoreList.find('option:not(:first)').remove();
        $.each(storesList, function (index, storeName) {
            $cityWiseStoreList.append(
                `<option value="${storeName}">${storeName}</option>`
            );
        });
    }

    function getHubSpotCookie() {
        const match = document.cookie.match(/hubspotutk=([^;]+)/);
        return match ? match[1] : null;
    }

    function getUserIP() {
        return fetch('https://api.ipify.org?format=json')
            .then(response => response.json())
            .then(data => data.ip)
            .catch(error => {
                console.error('Could not fetch IP:', error);
                return null;
            });
    }

    $.validator.addMethod('optional_email_rule', function (value, element) {

        // If the field is empty and not required, skip validation
        if (this.optional(element)) {
            return true;
        }

        value = $.trim(value);

        // Reject spaces anywhere in the email
        if (/\s/.test(value)) {
            return false;
        }

        // Must have exactly one @
        var parts = value.split('@');
        if (parts.length !== 2) {
            return false;
        }

        var localPart = parts[0];
        var domainPart = parts[1];

        // Local part cannot start/end with dot
        if (/^\./.test(localPart) || /\.$/.test(localPart)) {
            return false;
        }

        // Local part cannot have consecutive dots
        if (/\.\./.test(localPart)) {
            return false;
        }

        // Domain part cannot start/end with dot
        if (/^\./.test(domainPart) || /\.$/.test(domainPart)) {
            return false;
        }

        // Domain part cannot have consecutive dots
        if (/\.\./.test(domainPart)) {
            return false;
        }

        // Overall format
        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

        return emailRegex.test(value);

    }, 'Please enter a valid email address');

    $.validator.addMethod('email_rule', function (value, element) {
        // 1. Trim spaces from start and end
        value = value.trim();

        // 2. Reject spaces anywhere in the email
        if (/\s/.test(value)) {
            return false;
        }

        // 3. Must have exactly one @
        var parts = value.split('@');
        if (parts.length !== 2) {
            return false;
        }

        var localPart = parts[0];
        var domainPart = parts[1];

        // 4. Local part cannot start or end with a dot
        if (/^\./.test(localPart) || /\.$/.test(localPart)) {
            return false;
        }

        // 5. Local part cannot have consecutive dots
        if (/\.\./.test(localPart)) {
            return false;
        }

        // 6. Domain part cannot start or end with a dot
        if (/^\./.test(domainPart) || /\.$/.test(domainPart)) {
            return false;
        }

        // 7. Domain part cannot have consecutive dots
        if (/\.\./.test(domainPart)) {
            return false;
        }

        // 8. Use regex to check overall format
        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!emailRegex.test(value)) {
            return false;
        }

        // Passed all checks
        return true;
    }, 'Please enter a valid email address');

    $(".spaceRemove").on("keypress keyup blur", function (event) {
        $(this).val($(this).val().replace(/\s/g, ""));
        if (event.which === 32) {
            event.preventDefault();
        }
    });

    $.validator.addMethod('name_rule', function (value, element) {
        if (/^[a-zA-Z ]+$/.test(value)) {
            return true;
        } else {
            return false;
        };
    });

    $.validator.addMethod("trimmed", function (value, element) {
        return this.optional(element) || $.trim(value).length > 0;
    }, "This field cannot be empty after trimming.");

    $(document).on("keypress keyup blur", ".phone_number_only", function (event) {
        $(this).val($(this).val().replace(/[^\d].+/, ""));
        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });

    var paudRoadPune = $('#paudRoadPune').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/5ed332de-8a64-4029-9051-8d90b24abe2d", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var lucknowLandingPage = $('#lucknowLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) { 
                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/af387a14-ea06-47b9-8c1d-45715e7bdf84", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var dehradunLandingPage = $('#dehradunLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/864c63f7-3d90-4649-9e40-8d647fc82f88", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var vizagLandingPage = $('#vizagLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {
                
                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

                        { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },

                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/68a9e54d-b9a8-4aea-93c8-4f11808899dd", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var foundationDayLandingPage = $('#foundationDayLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            preferred_stores: {
                required: true
            },
            email: {
                required: true,
                email_rule: true
            },
            contact_numbers: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_date: {
                required: true
            },
            "occasion[]": {
                required: true,
            },
            "budget_range[]": {
                required: true,
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            preferred_stores: {
                required: "Please select store",
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            contact_numbers: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_date: {
                required: "Please select date",
            },
            "occasion[]": {
                required: "Please select your occasion",
            },
            "budget_range[]": {
                required: "Please select your budget range",
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "occasion") {
                error.insertAfter(".occasionErr");
            } else if (element.attr("id") == "budget_range") {
                error.insertAfter(".budgetRangeErr");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                var fullName = formData.get("full_name");
                var preferredStores = formData.get("preferred_stores");
                var emailAdd = formData.get("email");
                var contactNumbers = formData.get("contact_numbers");
                var preferredDate = formData.get("preferred_date");
                var occasionValues = formData.getAll("occasion[]").join(', ');
                var budgetValues = formData.getAll("budget_range[]").join(', ');

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "preferred_stores", value: formData.get("preferred_stores") },
                        { name: "email", value: formData.get("email") },
                        { name: "contact_numbers", value: formData.get("contact_numbers") },
                        { name: "preferred_date", value: formData.get("preferred_date") },
                        { name: "whats_the_occasion", value: occasionValues },
                        { name: "my_budget_range", value: budgetValues }
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/a250395f-ad7e-456a-9d3d-8f48fec1d729", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {
                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: contactNumbers,
                            store: preferredStores,
                            date: preferredDate,
                            occasion: occasionValues,
                            budget: budgetValues,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    // var ashtalakshmiLandingPage = $('#ashtalakshmiLandingPage').validate({
    //     ignore: ".ignore",
    //     rules: {
    //         full_name: {
    //             required: true,
    //             minlength: 2,
    //             name_rule: true,
    //             trimmed: true
    //         },
    //         email: {
    //             required: true,
    //             email_rule: true
    //         },
    //         phone: {
    //             required: true,
    //             minlength: 10,
    //             maxlength: 10,
    //         },
    //         "occasion[]": {
    //             required: true,
    //         },
    //         "budget_range[]": {
    //             required: true,
    //         },
    //         hiddenRecaptcha: {
    //             required: function () {
    //                 console.log(grecaptcha.getResponse(0));
    //                 if (grecaptcha.getResponse(0) == '') {
    //                     return true;
    //                 } else {
    //                     return false;
    //                 }
    //             }
    //         }
    //     },
    //     messages: {
    //         full_name: {
    //             required: "Please enter your name",
    //             minlength: "Name must consist of at least 2 characters",
    //             name_rule: "Please enter valid name(alphabets only)"
    //         },
    //         email: {
    //             required: "Please enter your email",
    //             email_rule: "Please enter a valid email address"
    //         },
    //         phone: {
    //             required: "Please enter phone number",
    //             minlength: "Phone number must be at least 10 digits",
    //             maxlength: "Phone number must be no more than 10 digits"
    //         },
    //         "occasion[]": {
    //             required: "Please select your occasion",
    //         },
    //         "budget_range[]": {
    //             required: "Please select your budget range",
    //         },
    //         hiddenRecaptcha: {
    //             required: "Please confirm that you are not a robot."
    //         }
    //     },
    //     errorClass: 'error-validate-custom',
    //     errorElement: 'div',
    //     errorPlacement: function (error, element) {
    //         if (element.attr("id") == "occasion") {
    //             error.insertAfter(".occasionErr");
    //         } else if (element.attr("id") == "budget_range") {
    //             error.insertAfter(".budgetRangeErr");
    //         } else {
    //             element.after(error);
    //         }
    //     },
    //     submitHandler: function (form) {

    //         getUserIP().then(function(userIP) {

    //             $('.razorpay-sso-container').show();
    //             const formData = new FormData(form);

    //             var fullName = formData.get("full_name");
    //             var emailAdd = formData.get("email");
    //             var phoneNo = formData.get("phone");
    //             var occasionValues = formData.getAll("occasion[]").join(', ');
    //             var budgetValues = formData.getAll("budget_range[]").join(', ');

    //             const data = {
    //                 fields: [
    //                     { name: "full_name", value: formData.get("full_name") },
    //                     { name: "email", value: formData.get("email") },
    //                     { name: "phone", value: formData.get("phone") },
    //                     { name: "city", value: "-" },
    //                     { name: "whats_the_occasion", value: occasionValues },
    //                     { name: "my_budget_range", value: budgetValues }
    //                 ],
    //                 context: {
    //                     pageUri: window.location.href,
    //                     pageName: document.title,
    //                     hutk: getHubSpotCookie(),
    //                     ipAddress: userIP
    //                 }
    //             };

    //             fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/833cd337-651e-425b-8bf3-c7a0dbfe6e4e", {
    //                 method: "POST",
    //                 headers: {
    //                 "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(data)
    //             })
    //             .then(response => {
    //                 $('.razorpay-sso-container').hide();
    //                 if (response.ok) {
    //                     $('.errorLablePopup').hide();
    //                     form.reset();
    //                     grecaptcha.reset();

    //                     sessionStorage.setItem("hubspotData", JSON.stringify({
    //                         event: "hubspot_form_submit",
    //                         name: fullName,
    //                         email: emailAdd,
    //                         phone: phoneNo,
    //                         city: "-",
    //                         occasion: occasionValues,
    //                         budget: budgetValues,
    //                     }));

    //                     window.location.href = "https://aukerajewellery.com/pages/thank-you";

    //                 } else {
    //                     $('.thankYouLablePopup').hide();
    //                     $('.errorLablePopup').show();
    //                     setTimeout(function() {
    //                         $('.errorLablePopup').hide();
    //                     }, 3000);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //             });

    //         }).catch(function(error) {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //         });

    //     },
    // });

    // var extraBrilliantLandingPage = $('#extraBrilliantLandingPage').validate({
    //     ignore: ".ignore",
    //     rules: {
    //         full_name: {
    //             required: true,
    //             minlength: 2,
    //             name_rule: true,
    //             trimmed: true
    //         },
    //         email: {
    //             required: true,
    //             email_rule: true
    //         },
    //         phone: {
    //             required: true,
    //             minlength: 10,
    //             maxlength: 10,
    //         },
    //         city: {
    //             required: true
    //         },
    //         preferred_store: {
    //             required: true
    //         },
    //         "occasion[]": {
    //             required: true,
    //         },
    //         hiddenRecaptcha: {
    //             required: function () {
    //                 console.log(grecaptcha.getResponse(0));
    //                 if (grecaptcha.getResponse(0) == '') {
    //                     return true;
    //                 } else {
    //                     return false;
    //                 }
    //             }
    //         }
    //     },
    //     messages: {
    //         full_name: {
    //             required: "Please enter your name",
    //             minlength: "Name must consist of at least 2 characters",
    //             name_rule: "Please enter valid name(alphabets only)"
    //         },
    //         email: {
    //             required: "Please enter your email",
    //             email_rule: "Please enter a valid email address"
    //         },
    //         phone: {
    //             required: "Please enter phone number",
    //             minlength: "Phone number must be at least 10 digits",
    //             maxlength: "Phone number must be no more than 10 digits"
    //         },
    //         city: {
    //             required: "Please select your city"
    //         },
    //         preferred_store: {
    //             required: "Please select store"
    //         },
    //         "occasion[]": {
    //             required: "Please select your occasion",
    //         },
    //         hiddenRecaptcha: {
    //             required: "Please confirm that you are not a robot."
    //         }
    //     },
    //     errorClass: 'error-validate-custom',
    //     errorElement: 'div',
    //     errorPlacement: function (error, element) {
    //         if (element.attr("id") == "occasion") {
    //             error.insertAfter(".occasionErr");
    //         } else {
    //             element.after(error);
    //         }
    //     },
    //     submitHandler: function (form) {

    //         getUserIP().then(function(userIP) {

    //             $('.razorpay-sso-container').show();
    //             const formData = new FormData(form);

    //             const utmData = getUTMParameters();

    //             var fullName = formData.get("full_name");
    //             var emailAdd = formData.get("email");
    //             var phoneNo = formData.get("phone");
    //             var cityName = formData.get("city");
    //             var storeName = formData.get("preferred_store");
    //             var occasionValues = formData.getAll("occasion[]").join(', ');

    //             const data = {
    //                 fields: [
    //                     { name: "full_name", value: formData.get("full_name") },
    //                     { name: "email", value: formData.get("email") },
    //                     { name: "phone", value: formData.get("phone") },
    //                     { name: "city", value: formData.get("city") },
    //                     { name: "preferred_store", value: formData.get("preferred_store") },
    //                     { name: "whats_the_occasion", value: occasionValues },

	//                     { name: "utm_source", value: utmData.utm_source },
	//                     { name: "utm_medium", value: utmData.utm_medium },
	//                     { name: "utm_campaign", value: utmData.utm_campaign },
	//                     { name: "utm_adgroup", value: utmData.utm_adgroup },
	//                     { name: "utm_adset", value: utmData.utm_adset },
	//                     { name: "utm_term", value: utmData.utm_term },
	//                     { name: "utm_ad", value: utmData.utm_ad },
	//                     { name: "utm_city", value: utmData.utm_city },
	//                     { name: "utm_destination", value: utmData.utm_destination },
    //                 ],
    //                 context: {
    //                     pageUri: window.location.href,
    //                     pageName: document.title,
    //                     hutk: getHubSpotCookie(),
    //                     ipAddress: userIP
    //                 }
    //             };

    //             fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/9f09bb01-ed06-4310-b30b-51487de973ae", {
    //                 method: "POST",
    //                 headers: {
    //                 "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(data)
    //             })
    //             .then(response => {
    //                 $('.razorpay-sso-container').hide();
    //                 if (response.ok) {

    //                     $('.errorLablePopup').hide();
    //                     form.reset();
    //                     grecaptcha.reset();

    //                     sessionStorage.setItem("hubspotData", JSON.stringify({
    //                         event: "hubspot_form_submit",
    //                         name: fullName,
    //                         email: emailAdd,
    //                         phone: phoneNo,
    //                         city: cityName,
    //                         store: storeName,
    //                         occasion: occasionValues,

    //                         utm_source: utmData.utm_source,
    //                         utm_medium: utmData.utm_medium,
    //                         utm_campaign: utmData.utm_campaign,
    //                         utm_adgroup: utmData.utm_adgroup,
    //                         utm_adset: utmData.utm_adset,
    //                         utm_term: utmData.utm_term,
    //                         utm_ad: utmData.utm_ad,
    //                         utm_city: utmData.utm_city,
    //                         utm_destination: utmData.utm_destination,
    //                     }));

    //                     window.location.href = "https://aukerajewellery.com/pages/thank-you";

    //                 } else {
    //                     $('.thankYouLablePopup').hide();
    //                     $('.errorLablePopup').show();
    //                     setTimeout(function() {
    //                         $('.errorLablePopup').hide();
    //                     }, 3000);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //             });

    //         }).catch(function(error) {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //         });



    //     },
    // });

    var bridalBangaloreForm = $('#bridalBangaloreForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/d05d5e24-88d2-41b6-9d1d-f505f8d26ffe", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalBangaloreFormMobile = $('#bridalBangaloreFormMobile').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(1));
                    if (grecaptcha.getResponse(1) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent_mob") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/d05d5e24-88d2-41b6-9d1d-f505f8d26ffe", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalHyderabadForm = $('#bridalHyderabadForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/20d889a8-84da-461f-a781-3df2d1de7f8b", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalHyderabadFormMobile = $('#bridalHyderabadFormMobile').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(1));
                    if (grecaptcha.getResponse(1) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent_mob") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/20d889a8-84da-461f-a781-3df2d1de7f8b", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalDelhiForm = $('#bridalDelhiForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/2577a45e-f4b2-4bb5-96e3-35872843a416", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var bridalDelhiFormMobile = $('#bridalDelhiFormMobile').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(1));
                    if (grecaptcha.getResponse(1) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent_mob") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/2577a45e-f4b2-4bb5-96e3-35872843a416", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    // var orchidForm = $('#orchidForm').validate({
    //     ignore: ".ignore",
    //     rules: {
    //         full_name: {
    //             required: true,
    //             minlength: 2,
    //             name_rule: true,
    //             trimmed: true
    //         },
    //         email: {
    //             required: true,
    //             email_rule: true
    //         },
    //         phone: {
    //             required: true,
    //             minlength: 10,
    //             maxlength: 10,
    //         },
    //         city: {
    //             required: true
    //         },
    //         preferred_store: {
    //             required: true
    //         },
    //         "occasion[]": {
    //             required: true,
    //         },
    //         hiddenRecaptcha: {
    //             required: function () {
    //                 console.log(grecaptcha.getResponse(0));
    //                 if (grecaptcha.getResponse(0) == '') {
    //                     return true;
    //                 } else {
    //                     return false;
    //                 }
    //             }
    //         }
    //     },
    //     messages: {
    //         full_name: {
    //             required: "Please enter your name",
    //             minlength: "Name must consist of at least 2 characters",
    //             name_rule: "Please enter valid name(alphabets only)"
    //         },
    //         email: {
    //             required: "Please enter your email",
    //             email_rule: "Please enter a valid email address"
    //         },
    //         phone: {
    //             required: "Please enter phone number",
    //             minlength: "Phone number must be at least 10 digits",
    //             maxlength: "Phone number must be no more than 10 digits"
    //         },
    //         city: {
    //             required: "Please select city"
    //         },
    //         preferred_store: {
    //             required: "Please select store"
    //         },
    //         "occasion[]": {
    //             required: "Please select your occasion",
    //         },
    //         hiddenRecaptcha: {
    //             required: "Please confirm that you are not a robot."
    //         }
    //     },
    //     errorClass: 'error-validate-custom',
    //     errorElement: 'div',
    //     errorPlacement: function (error, element) {
    //         if (element.attr("id") == "occasion") {
    //             error.insertAfter(".occasionErr");
    //         } else {
    //             element.after(error);
    //         }
    //     },
    //     submitHandler: function (form) {

    //         getUserIP().then(function(userIP) {

    //             $('.razorpay-sso-container').show();
    //             const formData = new FormData(form);

    //             const utmData = getUTMParameters();

    //             var fullName = formData.get("full_name");
    //             var emailAdd = formData.get("email");
    //             var phoneNo = formData.get("phone");
    //             var cityName = formData.get("city");
    //             var storeName = formData.get("preferred_store");
    //             var occasionValues = formData.getAll("occasion[]").join(', ');

    //             const data = {
    //                 fields: [
    //                     { name: "full_name", value: formData.get("full_name") },
    //                     { name: "email", value: formData.get("email") },
    //                     { name: "phone", value: formData.get("phone") },
    //                     { name: "city", value: formData.get("city") },
    //                     { name: "preferred_store", value: formData.get("preferred_store") },
    //                     { name: "whats_the_occasion", value: occasionValues },

	//                     { name: "utm_source", value: utmData.utm_source },
	//                     { name: "utm_medium", value: utmData.utm_medium },
	//                     { name: "utm_campaign", value: utmData.utm_campaign },
	//                     { name: "utm_adgroup", value: utmData.utm_adgroup },
	//                     { name: "utm_adset", value: utmData.utm_adset },
	//                     { name: "utm_term", value: utmData.utm_term },
	//                     { name: "utm_ad", value: utmData.utm_ad },
	//                     { name: "utm_city", value: utmData.utm_city },
	//                     { name: "utm_destination", value: utmData.utm_destination },
    //                 ],
    //                 context: {
    //                     pageUri: window.location.href,
    //                     pageName: document.title,
    //                     hutk: getHubSpotCookie(),
    //                     ipAddress: userIP
    //                 }
    //             };

    //             fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/6ce753f3-c424-4220-af43-27d97ff2b0dd", {
    //                 method: "POST",
    //                 headers: {
    //                 "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(data)
    //             })
    //             .then(response => {
    //                 $('.razorpay-sso-container').hide();
    //                 if (response.ok) {

    //                     $('.errorLablePopup').hide();
    //                     form.reset();
    //                     grecaptcha.reset();

    //                     sessionStorage.setItem("hubspotData", JSON.stringify({
    //                         event: "hubspot_form_submit",
    //                         name: fullName,
    //                         email: emailAdd,
    //                         phone: phoneNo,
    //                         city: cityName,
    //                         store: storeName,
    //                         occasion: occasionValues,

    //                         utm_source: utmData.utm_source,
    //                         utm_medium: utmData.utm_medium,
    //                         utm_campaign: utmData.utm_campaign,
    //                         utm_adgroup: utmData.utm_adgroup,
    //                         utm_adset: utmData.utm_adset,
    //                         utm_term: utmData.utm_term,
    //                         utm_ad: utmData.utm_ad,
    //                         utm_city: utmData.utm_city,
    //                         utm_destination: utmData.utm_destination,
    //                     }));

    //                     window.location.href = "https://aukerajewellery.com/pages/thank-you";

    //                 } else {
    //                     $('.thankYouLablePopup').hide();
    //                     $('.errorLablePopup').show();
    //                     setTimeout(function() {
    //                         $('.errorLablePopup').hide();
    //                     }, 3000);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //             });

    //         }).catch(function(error) {
    //             console.error(error);
    //             $('.razorpay-sso-container').hide();
    //             $('.thankYouLablePopup').hide();
    //             $('.errorLablePopup').show();
    //             setTimeout(function() {
    //                 $('.errorLablePopup').hide();
    //             }, 3000);
    //         });



    //     },
    // });

    // var bridalForm = $('#bridalForm').validate({
    //     ignore: ".ignore",
    //     rules: {
    //         full_name: {
    //             required: true,
    //             minlength: 2,
    //             name_rule: true,
    //             trimmed: true
    //         },
    //         email: {
    //             required: true,
    //             email_rule: true
    //         },
    //         phone: {
    //             required: true,
    //             minlength: 10,
    //             maxlength: 10,
    //         },
    //         city: {
    //             required: true
    //         },
    //         preferred_store: {
    //             required: true
    //         },
    //         "occasion[]": {
    //             required: true,
    //         },
    //         hiddenRecaptcha: {
    //             required: function () {
    //                 console.log(grecaptcha.getResponse(0));
    //                 if (grecaptcha.getResponse(0) == '') {
    //                     return true;
    //                 } else {
    //                     return false;
    //                 }
    //             }
    //         }
    //     },
    //     messages: {
    //         full_name: {
    //             required: "Please enter your name",
    //             minlength: "Name must consist of at least 2 characters",
    //             name_rule: "Please enter valid name(alphabets only)"
    //         },
    //         email: {
    //             required: "Please enter your email",
    //             email_rule: "Please enter a valid email address"
    //         },
    //         phone: {
    //             required: "Please enter phone number",
    //             minlength: "Phone number must be at least 10 digits",
    //             maxlength: "Phone number must be no more than 10 digits"
    //         },
    //         city: {
    //             required: "Please select city"
    //         },
    //         preferred_store: {
    //             required: "Please select store"
    //         },
    //         "occasion[]": {
    //             required: "Please select your occasion",
    //         },
    //         hiddenRecaptcha: {
    //             required: "Please confirm that you are not a robot."
    //         }
    //     },
    //     errorClass: 'error-validate-custom',
    //     errorElement: 'div',
    //     errorPlacement: function (error, element) {
    //         if (element.attr("id") == "occasion") {
    //             error.insertAfter(".occasionErr");
    //         } else {
    //             element.after(error);
    //         }
    //     },
    //     submitHandler: function (form) {

    //         getUserIP().then(function(userIP) {

    //             $('.razorpay-sso-container').show();
    //             const formData = new FormData(form);

    //             const utmData = getUTMParameters();

    //             var fullName = formData.get("full_name");
    //             var emailAdd = formData.get("email");
    //             var phoneNo = formData.get("phone");
    //             var cityName = formData.get("city");
    //             var storeName = formData.get("preferred_store");
    //             var occasionValues = formData.getAll("occasion[]").join(', ');

    //             const data = {
    //                 fields: [
    //                     { name: "full_name", value: formData.get("full_name") },
    //                     { name: "email", value: formData.get("email") },
    //                     { name: "phone", value: formData.get("phone") },
    //                     { name: "city", value: formData.get("city") },
    //                     { name: "preferred_store", value: formData.get("preferred_store") },
    //                     { name: "whats_the_occasion", value: occasionValues },

	//                     { name: "utm_source", value: utmData.utm_source },
	//                     { name: "utm_medium", value: utmData.utm_medium },
	//                     { name: "utm_campaign", value: utmData.utm_campaign },
	//                     { name: "utm_adgroup", value: utmData.utm_adgroup },
	//                     { name: "utm_adset", value: utmData.utm_adset },
	//                     { name: "utm_term", value: utmData.utm_term },
	//                     { name: "utm_ad", value: utmData.utm_ad },
	//                     { name: "utm_city", value: utmData.utm_city },
	//                     { name: "utm_destination", value: utmData.utm_destination },
    //                 ],
    //                 context: {
    //                     pageUri: window.location.href,
    //                     pageName: document.title,
    //                     hutk: getHubSpotCookie(),
    //                     ipAddress: userIP
    //                 }
    //             };

    //             fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/cb163526-dc4e-4f2e-9d38-5efc0cc73277", {
    //                 method: "POST",
    //                 headers: {
    //                 "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(data)
    //             })
    //             .then(response => {
    //                 $('.razorpay-sso-container').hide();
    //                 if (response.ok) {

    //                     $('.errorLablePopup').hide();
    //                     form.reset();
    //                     grecaptcha.reset();

    //                     sessionStorage.setItem("hubspotData", JSON.stringify({
    //                         event: "hubspot_form_submit",
    //                         name: fullName,
    //                         email: emailAdd,
    //                         phone: phoneNo,
    //                         city: cityName,
    //                         store: storeName,
    //                         occasion: occasionValues,

    //                         utm_source: utmData.utm_source,
    //                         utm_medium: utmData.utm_medium,
    //                         utm_campaign: utmData.utm_campaign,
    //                         utm_adgroup: utmData.utm_adgroup,
    //                         utm_adset: utmData.utm_adset,
    //                         utm_term: utmData.utm_term,
    //                         utm_ad: utmData.utm_ad,
    //                         utm_city: utmData.utm_city,
    //                         utm_destination: utmData.utm_destination,
    //                     }));

    //                     window.location.href = "https://aukerajewellery.com/pages/thank-you";

    //                 } else {
    //                     $('.thankYouLablePopup').hide();
    //                     $('.errorLablePopup').show();
    //                     setTimeout(function() {
    //                         $('.errorLablePopup').hide();
    //                     }, 3000);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //             });

    //         }).catch(function(error) {
    //             console.error(error);
    //             $('.razorpay-sso-container').hide();
    //             $('.thankYouLablePopup').hide();
    //             $('.errorLablePopup').show();
    //             setTimeout(function() {
    //                 $('.errorLablePopup').hide();
    //             }, 3000);
    //         });



    //     },
    // });

    // var giftingForm = $('#giftingForm').validate({
    //     ignore: ".ignore",
    //     rules: {
    //         full_name: {
    //             required: true,
    //             minlength: 2,
    //             name_rule: true,
    //             trimmed: true
    //         },
    //         email: {
    //             required: true,
    //             email_rule: true
    //         },
    //         phone: {
    //             required: true,
    //             minlength: 10,
    //             maxlength: 10,
    //         },
    //         city: {
    //             required: true
    //         },
    //         preferred_store: {
    //             required: true
    //         },
    //         "occasion[]": {
    //             required: true,
    //         },
    //         hiddenRecaptcha: {
    //             required: function () {
    //                 console.log(grecaptcha.getResponse(0));
    //                 if (grecaptcha.getResponse(0) == '') {
    //                     return true;
    //                 } else {
    //                     return false;
    //                 }
    //             }
    //         }
    //     },
    //     messages: {
    //         full_name: {
    //             required: "Please enter your name",
    //             minlength: "Name must consist of at least 2 characters",
    //             name_rule: "Please enter valid name(alphabets only)"
    //         },
    //         email: {
    //             required: "Please enter your email",
    //             email_rule: "Please enter a valid email address"
    //         },
    //         phone: {
    //             required: "Please enter phone number",
    //             minlength: "Phone number must be at least 10 digits",
    //             maxlength: "Phone number must be no more than 10 digits"
    //         },
    //         city: {
    //             required: "Please select city"
    //         },
    //         preferred_store: {
    //             required: "Please select store"
    //         },
    //         "occasion[]": {
    //             required: "Please select your occasion",
    //         },
    //         hiddenRecaptcha: {
    //             required: "Please confirm that you are not a robot."
    //         }
    //     },
    //     errorClass: 'error-validate-custom',
    //     errorElement: 'div',
    //     errorPlacement: function (error, element) {
    //         if (element.attr("id") == "occasion") {
    //             error.insertAfter(".occasionErr");
    //         } else {
    //             element.after(error);
    //         }
    //     },
    //     submitHandler: function (form) {

    //         getUserIP().then(function(userIP) {

    //             $('.razorpay-sso-container').show();
    //             const formData = new FormData(form);

    //             const utmData = getUTMParameters();

    //             var fullName = formData.get("full_name");
    //             var emailAdd = formData.get("email");
    //             var phoneNo = formData.get("phone");
    //             var cityName = formData.get("city");
    //             var storeName = formData.get("preferred_store");
    //             var occasionValues = formData.getAll("occasion[]").join(', ');

    //             const data = {
    //                 fields: [
    //                     { name: "full_name", value: formData.get("full_name") },
    //                     { name: "email", value: formData.get("email") },
    //                     { name: "phone", value: formData.get("phone") },
    //                     { name: "city", value: formData.get("city") },
    //                     { name: "preferred_store", value: formData.get("preferred_store") },
    //                     { name: "whats_the_occasion", value: occasionValues },

	//                     { name: "utm_source", value: utmData.utm_source },
	//                     { name: "utm_medium", value: utmData.utm_medium },
	//                     { name: "utm_campaign", value: utmData.utm_campaign },
	//                     { name: "utm_adgroup", value: utmData.utm_adgroup },
	//                     { name: "utm_adset", value: utmData.utm_adset },
	//                     { name: "utm_term", value: utmData.utm_term },
	//                     { name: "utm_ad", value: utmData.utm_ad },
	//                     { name: "utm_city", value: utmData.utm_city },
	//                     { name: "utm_destination", value: utmData.utm_destination },
    //                 ],
    //                 context: {
    //                     pageUri: window.location.href,
    //                     pageName: document.title,
    //                     hutk: getHubSpotCookie(),
    //                     ipAddress: userIP
    //                 }
    //             };

    //             fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/f7711b9e-6f16-4fb7-bda4-fbe404dea78e", {
    //                 method: "POST",
    //                 headers: {
    //                 "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify(data)
    //             })
    //             .then(response => {
    //                 $('.razorpay-sso-container').hide();
    //                 if (response.ok) {

    //                     $('.errorLablePopup').hide();
    //                     form.reset();
    //                     grecaptcha.reset();

    //                     sessionStorage.setItem("hubspotData", JSON.stringify({
    //                         event: "hubspot_form_submit",
    //                         name: fullName,
    //                         email: emailAdd,
    //                         phone: phoneNo,
    //                         city: cityName,
    //                         store: storeName,
    //                         occasion: occasionValues,

    //                         utm_source: utmData.utm_source,
    //                         utm_medium: utmData.utm_medium,
    //                         utm_campaign: utmData.utm_campaign,
    //                         utm_adgroup: utmData.utm_adgroup,
    //                         utm_adset: utmData.utm_adset,
    //                         utm_term: utmData.utm_term,
    //                         utm_ad: utmData.utm_ad,
    //                         utm_city: utmData.utm_city,
    //                         utm_destination: utmData.utm_destination,
    //                     }));

    //                     window.location.href = "https://aukerajewellery.com/pages/thank-you";

    //                 } else {
    //                     $('.thankYouLablePopup').hide();
    //                     $('.errorLablePopup').show();
    //                     setTimeout(function() {
    //                         $('.errorLablePopup').hide();
    //                     }, 3000);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error(error);
    //                 $('.razorpay-sso-container').hide();
    //                 $('.thankYouLablePopup').hide();
    //                 $('.errorLablePopup').show();
    //                 setTimeout(function() {
    //                     $('.errorLablePopup').hide();
    //                 }, 3000);
    //             });

    //         }).catch(function(error) {
    //             console.error(error);
    //             $('.razorpay-sso-container').hide();
    //             $('.thankYouLablePopup').hide();
    //             $('.errorLablePopup').show();
    //             setTimeout(function() {
    //                 $('.errorLablePopup').hide();
    //             }, 3000);
    //         });



    //     },
    // });

    var mothersDay2026 = $('#mothersDay2026').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            choice_your_mother_made: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            choice_your_mother_made: {
                required: "Please enter choice your mother made"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            element.after(error);
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var choiceYourMotherMade = formData.get("choice_your_mother_made");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "choice_your_mother_made", value: formData.get("choice_your_mother_made") },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/dae77e6b-4e49-47d2-b394-9d5566d256d7", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            phone: phoneNo,
                            city: cityName,
                            choice_your_mother_made: choiceYourMotherMade,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var ambienceMallNewDelhi = $('#ambienceMallNewDelhi').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/9024fb03-10fe-454e-b81c-62d08fd3c373", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var bigRockFest = $('#bigRockFest').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "occasion") {
                error.insertAfter(".occasionErr");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/f2ee91f7-bbd9-486e-900e-e9decb718cc8", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var bigRockFest2026 = $('#bigRockFest2026').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "occasion") {
                error.insertAfter(".occasionErr");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/b99dd020-eeab-48a5-8942-b447d1f88aa0", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var contactUsPageForm = $('#contactUsPageForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            preferred_store: {
                required: true
            },
            type_of_enquiry: {
                required: true
            },
            message: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select your city"
            },
            preferred_store: {
                required: "Please select store"
            },
            type_of_enquiry: {
                required: "Please select type of enquiry"
            },
            message: {
                 required: "Please enter your message"
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "phone") {
                error.insertAfter(".phoneNumVali");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");
                var typeOfEnquiry = formData.get("type_of_enquiry");
                var message = formData.get("message");

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "type_of_enquiry", value: formData.get("type_of_enquiry") },
                        { name: "message", value: formData.get("message") },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/b4addd46-f603-4fc9-949b-48e33dae1e49", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName,
                            type_of_enquiry: typeOfEnquiry,
                            message: message,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });



        },
    });

    var banashankariBangaloreForm = $('#banashankariBangaloreForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                       { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/6c8b2a2a-885e-4305-acc9-c73e534fa286", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    if ($('.select2').length) {
        $('.select2').each(function() {
            $(this).select2({
            placeholder: $(this).data('placeholder'),
            allowClear: true
            });
        });
    }

    var newLandbridalForm = $('#newLandbridalForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/cb163526-dc4e-4f2e-9d38-5efc0cc73277", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityLandingPage = $('#cityLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var brandLandingForm = $('#brandLandingForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/0100126d-2a8d-41fb-b4ad-82aeb64ed5d3", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var landingBridalRingsLimiteddrop = $('#landingBridalRingsLimiteddrop').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                required: true,
                email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                required: "Please enter your email",
                email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "occasion") {
                error.insertAfter(".occasionErr");
            }
            else if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            }
            else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/d1cdd12f-42ea-486f-8769-ae78ec855ba5", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var bridalPagesForms = $('#bridalPagesForms').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            $('.razorpay-sso-container').show();
            const formData = new FormData(form);

            const utmData = getUTMParameters();

            var fullName = formData.get("full_name");
            var emailAdd = formData.get("email");
            var phoneNo = formData.get("phone");
            var cityName = formData.get("city");
            var isConsent = formData.get("is_consent") ? "Yes" : "No";
            var zigment_consent = formData.get("is_consent") ? 'true' : 'false';
        
            try {
                const data = {
                    submission_id: zigmentSubmissionId,

                    fields: {
                        full_name: fullName,
                        email: emailAdd,
                        phone: phoneNo,
                        city: cityName,
                        is_consent: isConsent,
                        _consent: zigment_consent,
                        _hp: ""
                    },
                    context: {
                            page_url: window.location.href,
                            page_title: document.title,
                            referrer: document.referrer,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                            utm_content: utmData.utm_content,
                            gclid: utmData.gclid,
                            fbclid: utmData.fbclid
                    }
                };

                fetch("https://api.zigment.ai/v2/public/forms/frm_343bdf031137bba9/submissions", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("zigmentData", JSON.stringify({
                            event: "zigment_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            } catch (error) {

                console.error("Zigment API error:", error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();

                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            }

        },
    });

    var orchidPagesForms = $('#orchidPagesForms').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/6ce753f3-c424-4220-af43-27d97ff2b0dd", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var exoticPagesForms = $('#exoticPagesForms').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/28c5311f-6a08-4631-85f1-553f2f3c2fd5", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var giftingPagesForms = $('#giftingPagesForms').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/f7711b9e-6f16-4fb7-bda4-fbe404dea78e", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var extraBrilliantLandingPage = $('#extraBrilliantLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/9f09bb01-ed06-4310-b30b-51487de973ae", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var ashtalakshmiLandingPage = $('#ashtalakshmiLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/833cd337-651e-425b-8bf3-c7a0dbfe6e4e", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var orchidDelhiForm = $('#orchidDelhiForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/33b64b21-3fcf-4a2d-90f3-79d3b910e418", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });

        },
    });

    var orchidHyderabadForm = $('#orchidHyderabadForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/8f510474-ef5d-44d8-a155-760b0e571dd4", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });

        },
    });

    var orchidBangaloreForm = $('#orchidBangaloreForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/7726a7ad-a05e-4efe-881a-89bf170f6d02", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });

        },
    });

    var promiseKnotHyderabadForm = $('#promiseKnotHyderabadForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/0ea2dc42-8d18-4256-8264-ad80680de210", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });

        },
    });

    var promiseKnotDelhiForm = $('#promiseKnotDelhiForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/5241b42e-7420-426f-9304-01c907f0e188", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });

        },
    });

    var promiseKnotBangaloreForm = $('#promiseKnotBangaloreForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/efc0d67b-ff64-4552-b4ac-1e45f991a305", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });

        },
    });

    var storeLocatorForm = $('#storeLocatorForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var storeName = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/00fe2eec-1f3c-4999-9397-47f09d86bee7", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: storeName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var velacheryChennaiPageForm = $('#velacheryChennaiPageForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/def22d29-3d52-44fc-b14f-2517333c0453", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var vegaCityLandingPage = $('#vegaCityLandingPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/d4f15a7f-a84f-4445-bd21-68e8b41021d1", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var cityFormDehradunPage = $('#cityFormDehradunPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormDelhiPage = $('#cityFormDelhiPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormHyderabadPage = $('#cityFormHyderabadPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormPunePage = $('#cityFormPunePage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormBangalorePage = $('#cityFormBangalorePage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormChennaiPage = $('#cityFormChennaiPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormLucknowPage = $('#cityFormLucknowPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormVisakhapatnamPage = $('#cityFormVisakhapatnamPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormDelhiNCRCityPage = $('#cityFormDelhiNCRCityPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var giftCode = formData.get("gift_code");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "gift_code", value: formData.get("gift_code") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/41fec225-5f50-45a3-aa74-d378ca5eef07", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            gift_code: giftCode,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        var giftPDFLink = $('#gift_pdf_link').val();
                        if (giftPDFLink && giftPDFLink.trim() !== "") {
                            window.open(giftPDFLink.trim(), "_blank");
                        }
                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormDelhiNCRRegionPage = $('#cityFormDelhiNCRRegionPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var giftCode = formData.get("gift_code");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "gift_code", value: formData.get("gift_code") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/41fec225-5f50-45a3-aa74-d378ca5eef07", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            gift_code: giftCode,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        var giftPDFLink = $('#gift_pdf_link').val();
                        if (giftPDFLink && giftPDFLink.trim() !== "") {
                            window.open(giftPDFLink.trim(), "_blank");
                        }                        
                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormNoidaPage = $('#cityFormNoidaPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormGurugramPage = $('#cityFormGurugramPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var cityFormFaridabadPage = $('#cityFormFaridabadPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            preferred_store: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            preferred_store: {
                required: "Please select store"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var preferredStore = formData.get("preferred_store");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "preferred_store", value: formData.get("preferred_store") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/3277d64e-21dd-4d20-afa4-99d0a5ecbaad", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            store: preferredStore,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var limitedDropOrchidForm = $('#limitedDropOrchidForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/e706f41d-7f9e-43a1-a2b4-46660596a205", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var dlfSummitGurugramStore = $('#dlfSummitGurugramStore').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/9c667b7d-d367-455a-8a19-c41e4195e804", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var amanoraPuneStore = $('#amanoraPuneStore').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/ac1e7948-bcce-49eb-9c6d-0be5033ae1ca", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var limitedDropWildflowerForm = $('#limitedDropWildflowerForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/e0994dbf-b264-4ace-819f-90a9264f47bf", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var forumSouthStoreLandPage = $('#forumSouthStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/f5989294-e07f-42bd-9bca-4a210713644a", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var mangalsutraForm = $('#mangalsutraForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/d3476f62-0abb-457f-8747-19b2a7d20c3a", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var ashtalakshmiVideoForm = $('#ashtalakshmiVideoForm').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            city: {
                required: true
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            city: {
                required: "Please select city"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/da24715e-f1dc-45e2-9928-4535101807ef", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,
                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.thankYouLablePopup').hide();
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.thankYouLablePopup').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                console.error(error);
                $('.razorpay-sso-container').hide();
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                    $('.errorLablePopup').hide();
                }, 3000);
            });



        },
    });

    var trunkShowForm = $('#trunkShowForm').validate({
        ignore: ".ignore",
        rules: {
        full_name: {
            required: true,
            minlength: 2,
            name_rule: true,
            trimmed: true
        },
        email: {
            optional_email_rule: true
        },
        phone: {
            required: true,
            minlength: 10,
            maxlength: 10,
        },
        preferred_store: {
            required: true
        },
        is_consent: {
            required: true
        },
        hiddenRecaptcha: {
            required: function () {
            console.log(grecaptcha.getResponse(0));
            if (grecaptcha.getResponse(0) == '') {
                return true;
            } else {
                return false;
            }
            }
        }
        },
        messages: {
        full_name: {
            required: "Please enter your name",
            minlength: "Name must consist of at least 2 characters",
            name_rule: "Please enter valid name(alphabets only)"
        },
        email: {
            optional_email_rule: "Please enter a valid email address"
        },
        phone: {
            required: "Please enter phone number",
            minlength: "Phone number must be at least 10 digits",
            maxlength: "Phone number must be no more than 10 digits"
        },
        preferred_store: {
            required: "Please select store"
        },
        is_consent: {
            required: "Please provide your consent to continue."
        },
        hiddenRecaptcha: {
            required: "Please confirm that you are not a robot."
        }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
        if (element.attr("id") == "is_consent") {
            error.insertAfter(".consentError");
        } else {
            element.after(error);
        }
        },
        submitHandler: function (form) {

        getUserIP().then(function(userIP) {

            $('.razorpay-sso-container').show();
            const formData = new FormData(form);

            const utmData = getUTMParameters();

            var fullName = formData.get("full_name");
            var emailAdd = formData.get("email");
            var phoneNo = formData.get("phone");
            var cityName = formData.get("city");
            var storeName = formData.get("preferred_store");
            var isConsent = formData.get("is_consent") ? "Yes" : "No";

            const data = {
            fields: [
                { name: "full_name", value: formData.get("full_name") },
                { name: "email", value: formData.get("email") },
                { name: "phone", value: formData.get("phone") },
                { name: "city", value: formData.get("city") },
                { name: "preferred_store", value: formData.get("preferred_store") },
                { name: "is_consent", value: isConsent },

                { name: "utm_source", value: utmData.utm_source },
                { name: "utm_medium", value: utmData.utm_medium },
                { name: "utm_campaign", value: utmData.utm_campaign },
                { name: "utm_adgroup", value: utmData.utm_adgroup },
                { name: "utm_adset", value: utmData.utm_adset },
                { name: "utm_term", value: utmData.utm_term },
                { name: "utm_ad", value: utmData.utm_ad },
                { name: "utm_city", value: utmData.utm_city },
                { name: "utm_destination", value: utmData.utm_destination },
            ],
            context: {
                pageUri: window.location.href,
                pageName: document.title,
                hutk: getHubSpotCookie(),
                ipAddress: userIP
            }
            };

            fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/76b5ec25-cf16-4985-8cb3-5f370001b952", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
            })
            .then(response => {
            $('.razorpay-sso-container').hide();
            if (response.ok) {

                $('.errorLablePopup').hide();
                form.reset();
                grecaptcha.reset();

                sessionStorage.setItem("hubspotData", JSON.stringify({
                event: "hubspot_form_submit",
                name: fullName,
                email: emailAdd,
                phone: phoneNo,
                city: cityName,
                store: storeName,
                consent: isConsent,

                utm_source: utmData.utm_source,
                utm_medium: utmData.utm_medium,
                utm_campaign: utmData.utm_campaign,
                utm_adgroup: utmData.utm_adgroup,
                utm_adset: utmData.utm_adset,
                utm_term: utmData.utm_term,
                utm_ad: utmData.utm_ad,
                utm_city: utmData.utm_city,
                utm_destination: utmData.utm_destination,
                }));

                window.location.href = "https://aukerajewellery.com/pages/thank-you";

            } else {
                $('.thankYouLablePopup').hide();
                $('.errorLablePopup').show();
                setTimeout(function() {
                $('.errorLablePopup').hide();
                }, 3000);
            }
            })
            .catch(error => {
            console.error(error);
            $('.razorpay-sso-container').hide();
            $('.thankYouLablePopup').hide();
            $('.errorLablePopup').show();
            setTimeout(function() {
                $('.errorLablePopup').hide();
            }, 3000);
            });

        }).catch(function(error) {
            console.error(error);
            $('.razorpay-sso-container').hide();
            $('.thankYouLablePopup').hide();
            $('.errorLablePopup').show();
            setTimeout(function() {
            $('.errorLablePopup').hide();
            }, 3000);
        });



        },
    });

    var dickensonRoadStoreLandPage = $('#dickensonRoadStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/c3f78147-e002-48e4-af35-c6f415d792a3", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var sarjapurStoreLandPage = $('#sarjapurStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/a5ca18f2-3d24-4105-8a52-2e2f2f926779", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var hsrLayoutStoreLandPage = $('#hsrLayoutStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/353addde-8b78-430a-8964-31d368e37240", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var electronicCityStoreLandPage = $('#electronicCityStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/6d73d578-ac45-4c5b-baa1-82a7fb0cde2f", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var jayanagarStoreLandPage = $('#jayanagarStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/24934bc0-e4bd-43d4-ae69-185b538d17d2", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var orionMallStoreLandPage = $('#orionMallStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/115b86b9-5723-4f1a-8427-0b302b282c24", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var whitefieldStoreLandPage = $('#whitefieldStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/9942ba3f-ca09-4ca7-ada4-6f4353f33094", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var marathahalliStoreLandPage = $('#marathahalliStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/55530512-6f18-4eb8-8610-3229c2574269", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var annaNagarStoreLandPage = $('#annaNagarStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/eafc6e69-6822-46f8-ab82-f3f7455156c6", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

    var indiranagarStoreLandPage = $('#indiranagarStoreLandPage').validate({
        ignore: ".ignore",
        rules: {
            full_name: {
                required: true,
                minlength: 2,
                name_rule: true,
                trimmed: true
            },
            email: {
                optional_email_rule: true
            },
            phone: {
                required: true,
                minlength: 10,
                maxlength: 10,
            },
            is_consent: {
                required: true
            },
            hiddenRecaptcha: {
                required: function () {
                    console.log(grecaptcha.getResponse(0));
                    if (grecaptcha.getResponse(0) == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            full_name: {
                required: "Please enter your name",
                minlength: "Name must consist of at least 2 characters",
                name_rule: "Please enter valid name(alphabets only)"
            },
            email: {
                optional_email_rule: "Please enter a valid email address"
            },
            phone: {
                required: "Please enter phone number",
                minlength: "Phone number must be at least 10 digits",
                maxlength: "Phone number must be no more than 10 digits"
            },
            is_consent: {
                required: "Please provide your consent to continue."
            },
            hiddenRecaptcha: {
                required: "Please confirm that you are not a robot."
            }
        },
        errorClass: 'error-validate-custom',
        errorElement: 'div',
        errorPlacement: function (error, element) {
            if (element.attr("id") == "is_consent") {
                error.insertAfter(".consentError");
            } else {
                element.after(error);
            }
        },
        submitHandler: function (form) {

            getUserIP().then(function(userIP) {

                $('.razorpay-sso-container').show();
                const formData = new FormData(form);

                const utmData = getUTMParameters();

                var fullName = formData.get("full_name");
                var emailAdd = formData.get("email");
                var phoneNo = formData.get("phone");
                var cityName = formData.get("city");
                var isConsent = formData.get("is_consent") ? "Yes" : "No";

                const data = {
                    fields: [
                        { name: "full_name", value: formData.get("full_name") },
                        { name: "email", value: formData.get("email") },
                        { name: "phone", value: formData.get("phone") },
                        { name: "city", value: formData.get("city") },
                        { name: "is_consent", value: isConsent },

	                    { name: "utm_source", value: utmData.utm_source },
	                    { name: "utm_medium", value: utmData.utm_medium },
	                    { name: "utm_campaign", value: utmData.utm_campaign },
	                    { name: "utm_adgroup", value: utmData.utm_adgroup },
	                    { name: "utm_adset", value: utmData.utm_adset },
	                    { name: "utm_term", value: utmData.utm_term },
	                    { name: "utm_ad", value: utmData.utm_ad },
	                    { name: "utm_city", value: utmData.utm_city },
	                    { name: "utm_destination", value: utmData.utm_destination },
                    ],
                    context: {
                        pageUri: window.location.href,
                        pageName: document.title,
                        hutk: getHubSpotCookie(),
                        ipAddress: userIP
                    }
                };

                fetch("https://api.hsforms.com/submissions/v3/integration/submit/44990263/f6aa648b-2ba6-44a8-951f-6ea06eae058b", {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
                .then(response => {
                    $('.razorpay-sso-container').hide();
                    if (response.ok) {

                        $('.errorLablePopup').hide();
                        form.reset();
                        grecaptcha.reset();

                        sessionStorage.setItem("hubspotData", JSON.stringify({
                            event: "hubspot_form_submit",
                            name: fullName,
                            email: emailAdd,
                            phone: phoneNo,
                            city: cityName,
                            consent: isConsent,

                            utm_source: utmData.utm_source,
                            utm_medium: utmData.utm_medium,
                            utm_campaign: utmData.utm_campaign,
                            utm_adgroup: utmData.utm_adgroup,
                            utm_adset: utmData.utm_adset,
                            utm_term: utmData.utm_term,
                            utm_ad: utmData.utm_ad,
                            utm_city: utmData.utm_city,
                            utm_destination: utmData.utm_destination,

                        }));

                        window.location.href = "https://aukerajewellery.com/pages/thank-you";

                    } else {
                        $('.errorLablePopup').show();
                        setTimeout(function() {
                            $('.errorLablePopup').hide();
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
                });

            }).catch(function(error) {
                    console.error(error);
                    $('.razorpay-sso-container').hide();
                    $('.errorLablePopup').show();
                    setTimeout(function() {
                        $('.errorLablePopup').hide();
                    }, 3000);
            });

        },
    });

});